var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-tap-editor',{attrs:{"simple":true},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})}
var staticRenderFns = []

export { render, staticRenderFns }